import DynamicColorRowHtml from '../../app-lite/grids/templates/row.dynamic-color.html';
import EditableCellHtml    from '../../app-lite/grids/templates/cell.editable.html';
import RemoveRowCellHtml   from '../../app-lite/grids/templates/cell.remove-row.html';

export function VehicleGroupsCtrl (
  $q,
  $scope,
  $timeout,
  $translate,
  gridAPI,
  messages,
  workshopAPI
) {
  $scope.itemsToDelete = [];

  $scope.grid = {
    columnDefs: [
      { displayName: '', enableCellEdit: false, cellTemplate: RemoveRowCellHtml, width: '43px'},
      { field: 'code', displayName:  $translate.instant('COMPANY_SPACE.SETTINGS.CODE'), enableCellEdit: true, cellEditableCondition: 'row.entity.new', editableCellTemplate: EditableCellHtml, width: '35%' },
      { field: 'description', displayName: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'), enableCellEdit: true, editableCellTemplate: EditableCellHtml}
    ],
    data: 'groups',
    enableCellSelection: true,
    enableRowSelection: false,
    enableCellEditOnFocus: true,
    rowHeight: 43,
    rowTemplate: DynamicColorRowHtml,
    virtualizationThreshold: 10000,
    selectedItems: $scope.currentRow
  };

  $scope.addItem = function () {
    $scope.groups.push({
      code: '',
      description: '',
      new: true
    });

    $timeout(function () {
      $('.' + $scope.grid.gridId).scrollTop($scope.grid.rowHeight * ($scope.groups.length + 1 ))
    });
  };

  $scope.removeItem = function (row) {
    var item = {};

    if (row.entity.new) {
      item = $scope.groups.splice(row.rowIndex, 1);
      return;
    }
    workshopAPI.get('/vehicle_body_group_types/can_destroy', row.entity.code)
    .then(function (deletable) {
      if (deletable === 'true') {
        item = $scope.groups.splice(row.rowIndex, 1);
        item[0].destroy = '1';

        $scope.itemsToDelete = $scope.itemsToDelete.concat(item);
      }
      else {
        messages.show($translate.instant('JS_SPACE.MESSAGES.VEHICLES_USING_BODY_TYPE'), 'error');
      }
    });
  };

  $scope.deleteItems = function () {
    var deferred = $q.defer();

    if ($scope.itemsToDelete.length) {
      workshopAPI.post('/vehicle_body_group_types', $scope.itemsToDelete, 'vehicle_body_group_types')
      .then(function (groups) {
        deferred.resolve(groups);
      }, function (err) {
        deferred.reject(err);
      });
    }
    else {
      deferred.resolve();
    }

    return deferred.promise;
  };

  $scope.save = function () {
    $scope.deleteItems().then(function () {
      workshopAPI.post('/vehicle_body_group_types', $scope.groups, 'vehicle_body_group_types')
      .then(function (groups) {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.VEHICLE_BODY_GROUP_TYPES'), 'success');

        angular.forEach(groups, function (group) {
          group.destroy = '0';
        });

        $scope.groups = groups;

      }, function (err) {
        messages.error(err);
      });
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.getRowColor = function (group, column) {
    const classes = gridAPI.getColumnClasses(column);

    if (group.new) {
      classes.push('bom-parent');
    }

    return classes;
  };

}
